export class GrupoProdutoEntity {
  ativado = true;
  descricao = null;

  constructor(grupoProduto) {
    if (grupoProduto.ativado === false) {
      this.ativado = false;
    }
    this.descricao = grupoProduto.descricao;
  }
}
